import { PaymentIconsProps } from '../@types/AcceptedPaymentMethodsProps';
import * as Icon from '../../Footer/images/index';

type PaymentMethodIconImageProps = {
	paymentMethod?: PaymentIconsProps;
	showInColor?: boolean;
};

const PaymentMethodIconImage = ({ paymentMethod, showInColor }: PaymentMethodIconImageProps) => {
	const iconIndex = `${paymentMethod!.replace(' ', '').toLowerCase()}${showInColor ? '' : 'Bw'}` as keyof typeof Icon;

	return (
		<img
			className={`vtex-store-footer-2-x-paymentMethodIconImage w-100 vtex-render-runtime-8-x-lazyload ls-is-cached lazyloaded`}
			src={Icon[iconIndex]}
			alt={paymentMethod}
		/>
	);
};

export default PaymentMethodIconImage;
